
export default {
  name: 'Notice',
  data() {
    return {
    }
  },
  computed: {
    noticesList() {
      return this.$t('news.list')
    }
  },
  methods: {
    linkNotices(item) {
      if(!item || !item.path) return
      this.$router.push({
        path: this.localePath(item.path)
      })
    },
    linkNoticesCenter() {
      // this.$router.push({path: '/news'})
      this.$router.push(this.localePath('/news'));
    }
  }
}
